import styled from 'styled-components';
import img from '../../assets/images/FooterBG.webp';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 120px 28px;
  background-image: url(${img});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: auto;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    padding-top: 55px;
    padding-bottom: 55px;
  }
`;

export const LogoContainer = styled.div`
  @media (max-width: 600px) {
    margin-bottom: 16px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media (max-width: 600px) {
    align-items: center;
  }
`;

export const SocialLinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 40px;
  & a {
    margin-left: 38px;
  }
  & svg {
    fill: #7c36cc;
  }
  @media (max-width: 600px) {
    & a {
      margin-left: 19px;
      margin-right: 19px;
    }
  }
`;

export const CopyrightText = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
  color: rgba(0, 0, 0, 0.5);
  @media (max-width: 600px) {
    margin-top: 25px;
    font-weight: 450;
    font-size: 14px;
    text-align: center;
  }
`;

export const FooterPages = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 130%;
  color: rgba(107, 112, 132, 1);
  margin: 5px 40px;
  text-align: center;
  text-decoration-line: underline;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
  @media (max-width: 600px) {
    font-size: 12px;
    padding: 8px 12px;
    margin: 0;
  }
`;
